import { createAction, props } from '@ngrx/store';
import { PagedOrders, OrderFiltersState } from 'src/app/core/orders/models/orders.models';

export const loadExportedData = createAction(
  '[Exported Data] Load Exported Data',
);

export const loadExportedDataSuccess = createAction(
  '[Exported Data] Load Exported Data Success',
  props<{ data: PagedOrders }>() // Data returned from the server
);

export const loadExportedDataFailure = createAction(
  '[Exported Data] Load Exported Data Failure',
  props<{ error: any }>() // Error object
);

export const updatedFilters = createAction(
  '[Exported Data] Update Filters',
  props<{ filters: Partial<OrderFiltersState> }>() // Filters to be updated
);

export const cleanFilters = createAction(
  '[Exported Data] Clean Filters'
);

export const cleanOneFilter = createAction(
  '[Exported Data] Clean One Filter',
  props<{ filter: string }>() 
);

export const applyFilters = createAction(
  '[Exported Data] Apply Filters',
  props<{ filters: any }>()
);


    export const exportOrders = createAction('[Orders] Export Orders');
    export const exportOrdersSuccess = createAction('[Orders] Export Orders Success', props<{ data: PagedOrders }>());
    export const exportOrdersFailure = createAction('[Orders] Export Orders Failure', props<{ error: any }>());